module.exports = __webpack_public_path__ + "static/media/search-fail.f4166a08.svg";